import { configureStore, ThunkAction, Action, combineReducers, PreloadedState } from '@reduxjs/toolkit';

import accountInfoReducer from './account-info/reducer';
import authReducer from './auth/reducer';
import bootstrapDataReducer from './boostrap-data/reducer';
import dashboardReducer from './dashboard/reducer';
import fedCalendarReducer from './fed-calendar/reducer';
import frontRunnerReducer from './front-runner/reducer';
import graphPresetReducer from './graph-preset/reducer';
import historicalDataReducer from './historical-data/reducer';
import legEventReducer from './leg-event/reducer';
import macroLinkReducer from './macro-link/reducer';
import macroNoteReducer from './macro-note/reducer';
import marketDataReducer from './market-data/reducer';
import openOrderReducer from './open-order/reducer';
import portfolioReducer from './portfolio/reducer';
import priceAlertReducer from './price-alert/reducer';
import quickNoteReducer from './quick-note/reducer';
import regimeAnalyticsReducer from './regime-analytics/reducer';
import securityReducer from './security/reducer';
import securityContractReducer from './security-contract/reducer';
import strategyReducer from './strategy/reducer';
import strategyEventReducer from './strategy-event/reducer';
import strategyLegReducer from './strategy-leg/reducer';
import systemProfileReducer from './system-profile/reducer';
import tradeReducer from './trade/reducer';
import tradeHistoryReducer from './trade-history/reducer';
import recentTradeReducer from './trade-recent/reducer';
import tradingClassReducer from './trading-class/reducer';
import trendLineReducer from './trend-line/reducer';
import userSettingsReducer from './user-settings/reducer';
import volatilityAlertReducer from './volatility-alert/reducer';
import volatilityProfileReducer from './volatility-profile/reducer';

export const rootReducer = combineReducers({
  userSettingsState: userSettingsReducer,
  authState: authReducer,
  accountInfoState: accountInfoReducer,
  tradingClassState: tradingClassReducer,
  securityContractState: securityContractReducer,
  marketDataState: marketDataReducer,
  legEventState: legEventReducer,
  openOrderState: openOrderReducer,
  historicalDataState: historicalDataReducer,
  securityState: securityReducer,
  macroNoteState: macroNoteReducer,
  dashboardState: dashboardReducer,
  frontRunnerState: frontRunnerReducer,
  tradeHistoryState: tradeHistoryReducer,
  macroLinkState: macroLinkReducer,
  trendLineState: trendLineReducer,
  bootstrapDataState: bootstrapDataReducer,
  quickNoteState: quickNoteReducer,
  portfolioState: portfolioReducer,
  priceAlertState: priceAlertReducer,
  systemProfileState: systemProfileReducer,
  strategyState: strategyReducer,
  strategyEventState: strategyEventReducer,
  strategyLegState: strategyLegReducer,
  fedCalendarState: fedCalendarReducer,
  volatilityProfileState: volatilityProfileReducer,
  volatilityAlertState: volatilityAlertReducer,
  graphPresetState: graphPresetReducer,
  regimeAnalyticsState: regimeAnalyticsReducer,
  tradeState: tradeReducer,
  recentTradeState: recentTradeReducer
});

export function setupStore(preloadedState?: PreloadedState<RootState>) {
  return configureStore({
    reducer: rootReducer,
    preloadedState
  });
}

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
